import React, { Component } from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Badge, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Breadcrumb from '../common/breadcrumb';
import { connect } from 'react-redux';
import { Plus, Edit2, Trash2, CheckCircle, FileText, Eye, Move, Type, Sliders, Settings, Layers, AlignLeft, AlignCenter, AlignRight } from 'react-feather';
import Swal from 'sweetalert2';
import { listCertificateTemplates, addCertificateTemplate, editCertificateTemplate, deleteCertificateTemplate, previewCertificateTemplate } from '../../Graphs/CertificateTemplate';
import { WEBURL } from '../../constant/comman';

class CertificateTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templates: [],
      isLoading: false,
      isModalOpen: false,
      isEditMode: false,
      selectedId: null,
      title: '',
      isDefault: false,
      pdfFile: null,
      existingPdfUrl: '',
      elements: [],
      activeElementId: null,
      activeDragElementId: null,
      dragCoords: null, // { x, y } for live drag tooltip
      activeTab: '1', // 1: Inspector/Elements, 2: Document Settings
      aspectRatio: 'landscape_a4', // landscape_a4 (842x595), landscape_letter (792x612), portrait_a4 (595x842)
      // Preview Modal
      isPreviewOpen: false,
      previewPdfUrl: '',
      isGeneratingPreview: false,
    };
  }

  componentDidMount() {
    this.fetchTemplates();
  }

  fetchTemplates = async () => {
    this.setState({ isLoading: true });
    try {
      const res = await listCertificateTemplates(this.props.authtoken);
      if (res && res.data) {
        this.setState({ templates: res.data });
      }
    } catch (err) {
      console.error("Failed to fetch templates:", err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  toggleModal = () => {
    const defaultElements = [
      { id: 'el_1', label: 'Student Name', type: 'text', text: '{{user_name}}', x: 421, y: 390, fontSize: 24, fontWeight: 'bold', fontStyle: 'normal', fontFamily: 'Helvetica', textTransform: 'none', characterSpacing: 0, fontColor: '#000000', alignment: 'center' },
      { id: 'el_2', label: 'Sub-text', type: 'text', text: 'for successfully completing the', x: 421, y: 360, fontSize: 12, fontWeight: 'normal', fontStyle: 'normal', fontFamily: 'Helvetica', textTransform: 'none', characterSpacing: 0, fontColor: '#000000', alignment: 'center' },
      { id: 'el_3', label: 'Course Title', type: 'text', text: '{{course_name}}', x: 421, y: 320, fontSize: 24, fontWeight: 'bold', fontStyle: 'normal', fontFamily: 'Helvetica', textTransform: 'none', characterSpacing: 0, fontColor: '#000000', alignment: 'center' },
      { id: 'el_4', label: 'Issued Date Label', type: 'text', text: 'Issued Date:', x: 421, y: 290, fontSize: 12, fontWeight: 'normal', fontStyle: 'normal', fontFamily: 'Helvetica', textTransform: 'none', characterSpacing: 0, fontColor: '#000000', alignment: 'center' },
      { id: 'el_5', label: 'Date Value', type: 'text', text: '{{completion_date}}', x: 421, y: 270, fontSize: 12, fontWeight: 'normal', fontStyle: 'normal', fontFamily: 'Helvetica', textTransform: 'none', characterSpacing: 0, fontColor: '#000000', alignment: 'center' },
      { id: 'el_6', label: 'Certificate Code', type: 'text', text: 'Certificate No: {{certificate_code}}', x: 421, y: 250, fontSize: 10, fontWeight: 'normal', fontStyle: 'normal', fontFamily: 'Helvetica', textTransform: 'none', characterSpacing: 0, fontColor: '#000000', alignment: 'center' }
    ];

    this.setState({
      isModalOpen: !this.state.isModalOpen,
      isEditMode: false,
      selectedId: null,
      title: '',
      isDefault: false,
      pdfFile: null,
      existingPdfUrl: '',
      elements: defaultElements,
      activeElementId: defaultElements[0].id,
      activeTab: '1',
      aspectRatio: 'landscape_a4'
    });
  };

  handleEdit = (template) => {
    this.setState({
      isModalOpen: true,
      isEditMode: true,
      selectedId: template._id,
      title: template.title || '',
      isDefault: template.is_default || false,
      existingPdfUrl: template.template_url || '',
      pdfFile: null,
      elements: template.elements || [],
      activeElementId: template.elements?.[0]?.id || null,
      activeTab: '1'
    });
  };

  handleDelete = async (id) => {
    console.log("🗑️ [FRONTEND] handleDelete triggered for ID:", id);

    if (!window.confirm("Are you sure you want to delete this certificate template?")) {
      return;
    }

    try {
      const res = await deleteCertificateTemplate(this.props.authtoken, id);
      if (res && (res.status == 200 || res.status == 201)) {
        alert("Certificate template deleted successfully!");
        this.fetchTemplates();
      } else {
        alert(res?.message || "Failed to delete certificate template");
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete certificate template");
    }
  };

  addElement = (type = 'text') => {
    const isParagraph = type === 'paragraph';
    const newEl = {
      id: `el_${Date.now()}`,
      label: isParagraph ? `Paragraph Block ${this.state.elements.length + 1}` : `Text Element ${this.state.elements.length + 1}`,
      type: type,
      text: isParagraph
        ? 'This is to acknowledge the attendance of {{user_name}} as a student of Trainovate (Approved Learning Partner Centre No.939) for {{course_name}} on {{completion_date}}.\n\nThis letter was given to {{user_name}} for proof of attendance from the training provider only. For further verification purposes, you may contact the undersigned.'
        : '{{user_name}}',
      x: isParagraph ? 60 : 421,
      y: isParagraph ? 380 : 300,
      width: isParagraph ? 660 : 400,
      lineHeight: 1.4,
      fontSize: isParagraph ? 14 : 20,
      fontWeight: isParagraph ? 'normal' : 'bold',
      fontStyle: 'normal',
      fontFamily: 'Helvetica', // Helvetica, Times, Courier
      textTransform: 'none', // none, uppercase, lowercase, capitalize
      characterSpacing: 0, // Letter spacing (pt)
      fontColor: '#000000',
      alignment: isParagraph ? 'left' : 'center'
    };

    this.setState(prevState => ({
      elements: [...prevState.elements, newEl],
      activeElementId: newEl.id
    }));
  };

  removeElement = (id) => {
    this.setState(prevState => ({
      elements: prevState.elements.filter(el => el.id !== id),
      activeElementId: prevState.activeElementId === id ? null : prevState.activeElementId
    }));
  };

  handleElementChange = (id, key, value) => {
    this.setState(prevState => ({
      elements: prevState.elements.map(el => {
        if (el.id === id) {
          return {
            ...el,
            [key]: key === 'x' || key === 'y' || key === 'fontSize' || key === 'width' || key === 'lineHeight' ? Number(value) : value
          };
        }
        return el;
      })
    }));
  };

  insertTagToElement = (id, tag) => {
    this.setState(prevState => ({
      elements: prevState.elements.map(el => {
        if (el.id === id) {
          return {
            ...el,
            text: el.text ? `${el.text} ${tag} ` : `${tag} `
          };
        }
        return el;
      })
    }));
  };

  // --- Visual Canvas Drag Engine ---
  handleMouseDown = (e, id) => {
    e.stopPropagation();
    this.setState({ activeDragElementId: id, activeElementId: id });
  };

  getPageDimensions = () => {
    const { aspectRatio } = this.state;
    if (aspectRatio === 'landscape_letter') return { width: 792, height: 612 };
    if (aspectRatio === 'portrait_a4') return { width: 595, height: 842 };
    return { width: 842, height: 595 }; // Default A4 Landscape
  };

  handleMouseMove = (e) => {
    const { activeDragElementId } = this.state;
    if (!activeDragElementId || !this.canvasContainer) return;

    const { width: pdfPageWidth, height: pdfPageHeight } = this.getPageDimensions();
    const containerRect = this.canvasContainer.getBoundingClientRect();
    const domX = e.clientX - containerRect.left;
    const domY = e.clientY - containerRect.top;

    const scaleX = pdfPageWidth / containerRect.width;
    const scaleY = pdfPageHeight / containerRect.height;

    const pdfX = Math.round(domX * scaleX);
    const pdfY = Math.round((containerRect.height - domY) * scaleY);

    const clampedX = Math.max(0, Math.min(pdfPageWidth, pdfX));
    const clampedY = Math.max(0, Math.min(pdfPageHeight, pdfY));

    this.handleElementChange(activeDragElementId, 'x', clampedX);
    this.handleElementChange(activeDragElementId, 'y', clampedY);
    this.setState({ dragCoords: { x: clampedX, y: clampedY } });
  };

  handleMouseUp = () => {
    if (this.state.activeDragElementId) {
      this.setState({ activeDragElementId: null, dragCoords: null });
    }
  };

  fileToBase64 = (file) => new Promise((resolve, reject) => {
    if (!file) return resolve(null);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  handleRowPreview = async (tpl) => {
    try {
      this.setState({ isGeneratingPreview: true });
      const payload = {
        template_url: tpl.template_url || '',
        elements: tpl.elements || []
      };

      const res = await previewCertificateTemplate(this.props.authtoken, payload);
      if (res && res.data && res.data.url) {
        const fullUrl = (WEBURL + res.data.url).replace(/([^:]\/)\/+/g, "$1");
        this.setState({
          previewPdfUrl: fullUrl,
          isPreviewOpen: true
        });
      } else {
        Swal.fire('Error', res?.message || 'Failed to generate preview PDF', 'error');
      }
    } catch (err) {
      console.error("Row preview error:", err);
      Swal.fire('Error', 'Failed to generate preview PDF', 'error');
    } finally {
      this.setState({ isGeneratingPreview: false });
    }
  };

  handleGeneratePreview = async () => {
    const { pdfFile, existingPdfUrl, elements } = this.state;

    try {
      this.setState({ isGeneratingPreview: true });
      let pdfBase64 = null;
      if (pdfFile) {
        pdfBase64 = await this.fileToBase64(pdfFile);
      }

      const payload = {
        template_url: existingPdfUrl,
        pdf_base64: pdfBase64,
        elements: elements
      };

      const res = await previewCertificateTemplate(this.props.authtoken, payload);
      if (res && res.data && res.data.url) {
        const fullUrl = (WEBURL + res.data.url).replace(/([^:]\/)\/+/g, "$1");
        this.setState({
          previewPdfUrl: fullUrl,
          isPreviewOpen: true
        });
      } else {
        Swal.fire('Error', res?.message || 'Failed to generate preview PDF', 'error');
      }
    } catch (err) {
      console.error("Preview error:", err);
      Swal.fire('Error', 'Failed to generate preview PDF', 'error');
    } finally {
      this.setState({ isGeneratingPreview: false });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { isEditMode, selectedId, title, isDefault, pdfFile, existingPdfUrl, elements } = this.state;

    if (!title || !title.trim()) {
      this.setState({ activeTab: '2' }, () => {
        Swal.fire('Error', 'Please enter a Template Title in Document Settings', 'error');
      });
      return;
    }

    try {
      this.setState({ isLoading: true });
      let pdfBase64 = null;
      if (pdfFile) {
        pdfBase64 = await this.fileToBase64(pdfFile);
      }

      const payload = {
        id: selectedId,
        title: title,
        is_default: isDefault,
        template_url: existingPdfUrl,
        pdf_base64: pdfBase64,
        elements: elements
      };

      let res;
      if (isEditMode) {
        res = await editCertificateTemplate(this.props.authtoken, payload);
      } else {
        res = await addCertificateTemplate(this.props.authtoken, payload);
      }

      if (res && (res.status === 200 || res.status === 201)) {
        Swal.fire('Success', isEditMode ? 'Template updated successfully' : 'Template created successfully', 'success');
        this.toggleModal();
        this.fetchTemplates();
      } else {
        Swal.fire('Error', res?.message || 'Operation failed', 'error');
      }
    } catch (err) {
      Swal.fire('Error', 'Failed to save certificate template', 'error');
    } finally {
      this.setState({ isLoading: false });
    }
  };

  renderVisualCanvas = () => {
    const { elements, activeElementId, existingPdfUrl, dragCoords, aspectRatio } = this.state;
    const { width: pdfPageWidth, height: pdfPageHeight } = this.getPageDimensions();

    const containerHeight = 440;
    const containerWidth = Math.round((pdfPageWidth / pdfPageHeight) * containerHeight);

    const getDomCoords = (el) => {
      const scaleX = containerWidth / pdfPageWidth;
      const scaleY = containerHeight / pdfPageHeight;
      const left = (el?.x || 0) * scaleX;
      const top = containerHeight - ((el?.y || 0) * scaleY);
      return { left, top };
    };

    return (
      <Card className="h-100 border shadow-sm" style={{ backgroundColor: '#f8fafc', borderRadius: '12px' }}>
        <CardHeader className="bg-white border-bottom py-2 px-3 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <Move size={18} className="mr-2 text-primary" />
            <h6 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>
              Canvas Stage ({pdfPageWidth}x{pdfPageHeight}pt)
            </h6>
          </div>
          <div className="d-flex align-items-center">
            <Input
              type="select"
              bsSize="sm"
              className="mr-2"
              style={{ width: '160px', color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
              value={aspectRatio}
              onChange={(e) => this.setState({ aspectRatio: e.target.value })}
            >
              <option value="landscape_a4">A4 Landscape (842x595)</option>
              <option value="landscape_letter">US Letter (792x612)</option>
              <option value="portrait_a4">A4 Portrait (595x842)</option>
            </Input>
            <div className="btn-group">
              <Button color="primary" size="sm" onClick={() => this.addElement('text')}>
                <Plus size={14} className="mr-1" /> + Text
              </Button>
              <Button color="info" size="sm" onClick={() => this.addElement('paragraph')}>
                <Type size={14} className="mr-1" /> + Paragraph
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardBody className="d-flex flex-column align-items-center justify-content-center p-3" style={{ overflow: 'hidden' }}>
          <div
            ref={(node) => (this.canvasContainer = node)}
            onMouseMove={this.handleMouseMove}
            onMouseUp={this.handleMouseUp}
            style={{
              width: `${containerWidth}px`,
              height: `${containerHeight}px`,
              position: 'relative',
              backgroundColor: '#ffffff',
              backgroundImage: existingPdfUrl ? `url(${existingPdfUrl})` : 'linear-gradient(45deg, #f1f5f9 25%, transparent 25%), linear-gradient(-45deg, #f1f5f9 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f1f5f9 75%), linear-gradient(-45deg, transparent 75%, #f1f5f9 75%)',
              backgroundSize: existingPdfUrl ? 'contain' : '20px 20px',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: existingPdfUrl ? 'center' : '0 0, 0 10px, 10px -10px, -10px 0px',
              border: '2px dashed #64748b',
              borderRadius: '8px',
              overflow: 'hidden',
              cursor: 'crosshair',
              userSelect: 'none',
              boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
            }}
          >
            {/* Center Reference Guide Line */}
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: 0,
                bottom: 0,
                width: '1px',
                borderLeft: '1px dashed rgba(59, 130, 246, 0.35)',
                pointerEvents: 'none',
                zIndex: 1
              }}
            />

            {/* Live Drag Coordinate Tooltip Badge */}
            {dragCoords && (
              <div
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  backgroundColor: '#0f172a',
                  color: '#38bdf8',
                  padding: '4px 10px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  zIndex: 100,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
              >
                📍 X: {dragCoords.x}px | Y: {dragCoords.y}px
              </div>
            )}

            {elements.length === 0 ? (
              <div className="d-flex flex-column align-items-center justify-content-center h-100" style={{ color: '#475569' }}>
                <Move size={40} className="mb-2 text-primary opacity-5" />
                <h6 className="font-weight-bold mb-1" style={{ color: '#0f172a' }}>Canvas Stage is Empty</h6>
                <small style={{ color: '#475569' }}>Click "+ Text" or "+ Paragraph" to add dynamic elements</small>
              </div>
            ) : (
              elements.map((el) => {
                const pos = getDomCoords(el);
                const isActive = activeElementId === el.id;
                const isParagraph = el.type === 'paragraph';
                const alignment = el.alignment || 'left';

                let transformStyle = 'none';
                if (alignment === 'center') {
                  transformStyle = 'translateX(-50%)';
                } else if (alignment === 'right') {
                  transformStyle = 'translateX(-100%)';
                }

                return (
                  <div
                    key={el.id}
                    onMouseDown={(e) => this.handleMouseDown(e, el.id)}
                    onClick={() => this.setState({ activeElementId: el.id })}
                    style={{
                      position: 'absolute',
                      left: `${pos.left}px`,
                      top: `${pos.top}px`,
                      transform: transformStyle,
                      backgroundColor: isActive ? (isParagraph ? 'rgba(2, 132, 199, 0.95)' : '#16a34a') : (isParagraph ? 'rgba(3, 105, 161, 0.85)' : '#15803d'),
                      color: '#ffffff',
                      padding: isParagraph ? '6px 12px' : '4px 10px',
                      borderRadius: '6px',
                      fontSize: '11px',
                      fontWeight: '600',
                      cursor: 'grab',
                      boxShadow: isActive ? '0 0 0 3px rgba(59, 130, 246, 0.5), 0 4px 12px rgba(0,0,0,0.15)' : '0 2px 6px rgba(0,0,0,0.15)',
                      whiteSpace: isParagraph ? 'normal' : 'nowrap',
                      width: isParagraph ? `${Math.round((el.width || 660) * (containerWidth / pdfPageWidth))}px` : 'auto',
                      border: isParagraph ? '1px dashed #ffffff' : 'none',
                      overflow: 'hidden',
                      zIndex: isActive ? 20 : 10,
                      transition: 'box-shadow 0.15s ease'
                    }}
                  >
                    {isParagraph ? `[Paragraph: ${el.label}] ${el.text || ''}` : `[Text] ${el.label}`}
                  </div>
                );
              })
            )}
          </div>
          <small className="mt-2 text-center" style={{ color: '#334155', fontWeight: '500' }}>
            💡 Drag elements to position. Centered items align on the dashed blue center guide line.
          </small>
        </CardBody>
      </Card>
    );
  };

  renderInspectorPanel = () => {
    const { elements, activeElementId, title, isDefault, existingPdfUrl, activeTab } = this.state;
    const colorSwatches = ['#000000', '#0f172a', '#1e40af', '#065f46', '#b45309', '#991b1b', '#475569'];

    return (
      <Card className="h-100 border shadow-sm" style={{ backgroundColor: '#ffffff', borderRadius: '12px' }}>
        <CardHeader className="bg-white border-bottom p-0">
          <Nav tabs className="border-0">
            <NavItem className="w-50 text-center">
              <NavLink
                className={`py-2 font-weight-bold ${activeTab === '1' ? 'active text-primary border-bottom border-primary' : 'text-secondary'}`}
                style={{ cursor: 'pointer', fontSize: '13px' }}
                onClick={() => this.setState({ activeTab: '1' })}
              >
                <Layers size={14} className="mr-1" /> Elements ({elements.length})
              </NavLink>
            </NavItem>
            <NavItem className="w-50 text-center">
              <NavLink
                className={`py-2 font-weight-bold ${activeTab === '2' ? 'active text-primary border-bottom border-primary' : 'text-secondary'}`}
                style={{ cursor: 'pointer', fontSize: '13px' }}
                onClick={() => this.setState({ activeTab: '2' })}
              >
                <Settings size={14} className="mr-1" /> Settings
                {(!title || !title.trim()) && (
                  <Badge color="danger" pill className="ml-1" style={{ fontSize: '9px', padding: '2px 6px' }}>Required</Badge>
                )}
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <CardBody className="p-3" style={{ height: 'calc(100% - 50px)', overflowY: 'auto' }}>
          <TabContent activeTab={activeTab}>
            {/* TAB 1: Elements Inspector */}
            <TabPane tabId="1">
              {elements.length === 0 ? (
                <div className="p-4 text-center border rounded bg-light" style={{ color: '#475569' }}>
                  No elements added yet. Click "+ Text" or "+ Paragraph" above to build your template!
                </div>
              ) : (
                elements.map((el) => {
                  const isActive = activeElementId === el.id;
                  const isParagraph = el.type === 'paragraph';

                  return (
                    <Card
                      key={el.id}
                      className={`p-3 mb-3 ${isActive ? 'shadow-sm' : ''}`}
                      style={{
                        borderRadius: '10px',
                        backgroundColor: '#ffffff',
                        border: isActive ? '2px solid #2563eb' : '1px solid #cbd5e1',
                        borderLeft: `6px solid ${isParagraph ? '#0284c7' : '#16a34a'}`,
                        transition: 'all 0.15s ease'
                      }}
                      onClick={() => this.setState({ activeElementId: el.id })}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <Badge color={isParagraph ? 'info' : 'success'} className="mr-2">
                            {isParagraph ? 'Paragraph' : 'Text'}
                          </Badge>
                          <Input
                            type="text"
                            className="form-control-sm font-weight-bold"
                            style={{ width: '180px', display: 'inline-block', color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                            value={el.label || ''}
                            onChange={(e) => this.handleElementChange(el.id, 'label', e.target.value)}
                            placeholder="Element Label"
                          />
                        </div>
                        <Button
                          color="link"
                          size="sm"
                          className="text-danger font-weight-bold d-flex align-items-center"
                          style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '6px', padding: '4px 10px', textDecoration: 'none', fontSize: '11px' }}
                          onClick={() => this.removeElement(el.id)}
                        >
                          <Trash2 size={12} className="mr-1 text-danger" /> Delete
                        </Button>
                      </div>

                      {/* Dynamic Tag Chips */}
                      <div className="mb-2">
                        <small className="d-block mb-1 font-weight-bold" style={{ color: '#475569' }}>Click tag chips to insert dynamic placeholders:</small>
                        <Button color="outline-primary" size="sm" className="mr-1 mb-1 py-0 px-2" style={{ fontSize: '11px' }} onClick={() => this.insertTagToElement(el.id, '{{user_name}}')}>
                          + Name {"({{user_name}})"}
                        </Button>
                        <Button color="outline-info" size="sm" className="mr-1 mb-1 py-0 px-2" style={{ fontSize: '11px' }} onClick={() => this.insertTagToElement(el.id, '{{course_name}}')}>
                          + Course {"({{course_name}})"}
                        </Button>
                        <Button color="outline-warning" size="sm" className="mr-1 mb-1 py-0 px-2" style={{ fontSize: '11px' }} onClick={() => this.insertTagToElement(el.id, '{{completion_date}}')}>
                          + Date {"({{completion_date}})"}
                        </Button>
                        <Button color="outline-secondary" size="sm" className="mb-1 py-0 px-2" style={{ fontSize: '11px' }} onClick={() => this.insertTagToElement(el.id, '{{certificate_code}}')}>
                          + Code {"({{certificate_code}})"}
                        </Button>
                      </div>

                      {/* Paragraph Style Formatting Help */}
                      {isParagraph && (
                        <div className="mb-2 p-2 rounded" style={{ backgroundColor: '#f0f9ff', border: '1px solid #bae6fd', fontSize: '11px', color: '#0369a1' }}>
                          💡 <strong>Inline Prop Styling Tip:</strong> Wrap tags in <code>&lt;b&gt;...&lt;/b&gt;</code> for Bold, <code>&lt;i&gt;...&lt;/i&gt;</code> for Italic, or <code>&lt;span color="#1e40af"&gt;...&lt;/span&gt;</code> for custom prop colors!
                          <br />
                          <em>Example: <code>{'attendance of <b color="#1e40af">{{user_name}}</b> for...'}</code></em>
                        </div>
                      )}

                      {/* Text Content */}
                      <FormGroup className="mb-2">
                        <Label className="font-weight-bold mb-1" style={{ fontSize: '12px', color: '#0f172a' }}>Text Content</Label>
                        <Input
                          type={isParagraph ? 'textarea' : 'text'}
                          rows={isParagraph ? 3 : 1}
                          style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                          value={el.text || ''}
                          onChange={(e) => this.handleElementChange(el.id, 'text', e.target.value)}
                          placeholder={isParagraph ? "Write paragraph text with dynamic tags..." : "Text content"}
                        />
                      </FormGroup>

                      {/* Presets & Color Swatches */}
                      <div className="d-flex align-items-center mb-2">
                        <small className="font-weight-bold mr-2" style={{ color: '#475569', fontSize: '11px' }}>Presets:</small>
                        {colorSwatches.map((hex) => (
                          <div
                            key={hex}
                            onClick={() => this.handleElementChange(el.id, 'fontColor', hex)}
                            style={{
                              width: '18px',
                              height: '18px',
                              backgroundColor: hex,
                              borderRadius: '50%',
                              cursor: 'pointer',
                              marginRight: '6px',
                              border: el.fontColor === hex ? '2px solid #2563eb' : '1px solid #cbd5e1'
                            }}
                          />
                        ))}
                      </div>

                      {/* Format and Position Controls */}
                      <Row form>
                        <Col md={3}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>X (px)</Label>
                            <Input
                              type="number"
                              size="sm"
                              style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                              value={el.x || 0}
                              onChange={(e) => this.handleElementChange(el.id, 'x', e.target.value)}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Y (px)</Label>
                            <Input
                              type="number"
                              size="sm"
                              style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                              value={el.y || 0}
                              onChange={(e) => this.handleElementChange(el.id, 'y', e.target.value)}
                            />
                          </FormGroup>
                        </Col>

                        {isParagraph && (
                          <React.Fragment>
                            <Col md={3}>
                              <FormGroup className="mb-2">
                                <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Width (px)</Label>
                                <Input
                                  type="number"
                                  size="sm"
                                  style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                                  value={el.width || 660}
                                  onChange={(e) => this.handleElementChange(el.id, 'width', e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup className="mb-2">
                                <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Line Height</Label>
                                <Input
                                  type="number"
                                  step="0.1"
                                  size="sm"
                                  style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                                  value={el.lineHeight || 1.4}
                                  onChange={(e) => this.handleElementChange(el.id, 'lineHeight', e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                          </React.Fragment>
                        )}

                        <Col md={3}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Font Size</Label>
                            <Input
                              type="number"
                              size="sm"
                              style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                              value={el.fontSize || 14}
                              onChange={(e) => this.handleElementChange(el.id, 'fontSize', e.target.value)}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={3}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Color</Label>
                            <Input
                              type="color"
                              size="sm"
                              style={{ color: '#0f172a', backgroundColor: '#ffffff' }}
                              value={el.fontColor || '#000000'}
                              onChange={(e) => this.handleElementChange(el.id, 'fontColor', e.target.value)}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={3}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Font Style</Label>
                            <div className="btn-group w-100" role="group">
                              <Button
                                type="button"
                                color={el.fontWeight === 'bold' ? 'primary' : 'outline-secondary'}
                                size="sm"
                                className="py-1 px-2 font-weight-bold"
                                style={{ fontSize: '11px' }}
                                onClick={() => this.handleElementChange(el.id, 'fontWeight', el.fontWeight === 'bold' ? 'normal' : 'bold')}
                                title="Toggle Bold"
                              >
                                <strong>B</strong>
                              </Button>
                              <Button
                                type="button"
                                color={el.fontStyle === 'italic' ? 'primary' : 'outline-secondary'}
                                size="sm"
                                className="py-1 px-2"
                                style={{ fontSize: '11px', fontStyle: 'italic', fontWeight: 'bold' }}
                                onClick={() => this.handleElementChange(el.id, 'fontStyle', el.fontStyle === 'italic' ? 'normal' : 'italic')}
                                title="Toggle Italic"
                              >
                                <i>I</i>
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>

                        {/* Font Family Dropdown */}
                        <Col md={4}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Font Family</Label>
                            <Input
                              type="select"
                              bsSize="sm"
                              style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1', fontSize: '11px' }}
                              value={el.fontFamily || 'Helvetica'}
                              onChange={(e) => this.handleElementChange(el.id, 'fontFamily', e.target.value)}
                            >
                              <option value="Helvetica">Helvetica (Sans-Serif)</option>
                              <option value="Times">Times Roman (Serif)</option>
                              <option value="Courier">Courier (Monospace)</option>
                            </Input>
                          </FormGroup>
                        </Col>

                        {/* Text Transform Dropdown */}
                        <Col md={4}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Text Transform</Label>
                            <Input
                              type="select"
                              bsSize="sm"
                              style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1', fontSize: '11px' }}
                              value={el.textTransform || 'none'}
                              onChange={(e) => this.handleElementChange(el.id, 'textTransform', e.target.value)}
                            >
                              <option value="none">Normal (As Typed)</option>
                              <option value="uppercase">UPPERCASE</option>
                              <option value="lowercase">lowercase</option>
                              <option value="capitalize">Capitalize Words</option>
                            </Input>
                          </FormGroup>
                        </Col>

                        {/* Letter Spacing Input */}
                        <Col md={4}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Letter Spacing (pt)</Label>
                            <Input
                              type="number"
                              step="0.5"
                              size="sm"
                              style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}
                              value={el.characterSpacing || 0}
                              onChange={(e) => this.handleElementChange(el.id, 'characterSpacing', e.target.value)}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={12}>
                          <FormGroup className="mb-2">
                            <Label style={{ fontSize: '11px', color: '#0f172a', fontWeight: '600' }}>Alignment</Label>
                            <div className="btn-group w-100" role="group">
                              <Button
                                type="button"
                                color={el.alignment === 'left' ? 'primary' : 'outline-secondary'}
                                size="sm"
                                className="py-1 px-1 font-weight-bold d-flex align-items-center justify-content-center"
                                style={{ fontSize: '11px' }}
                                onClick={() => this.handleElementChange(el.id, 'alignment', 'left')}
                              >
                                <AlignLeft size={13} className="mr-1" /> Left
                              </Button>
                              <Button
                                type="button"
                                color={el.alignment === 'center' ? 'primary' : 'outline-secondary'}
                                size="sm"
                                className="py-1 px-1 font-weight-bold d-flex align-items-center justify-content-center"
                                style={{ fontSize: '11px' }}
                                onClick={() => this.handleElementChange(el.id, 'alignment', 'center')}
                              >
                                <AlignCenter size={13} className="mr-1" /> Center
                              </Button>
                              <Button
                                type="button"
                                color={el.alignment === 'right' ? 'primary' : 'outline-secondary'}
                                size="sm"
                                className="py-1 px-1 font-weight-bold d-flex align-items-center justify-content-center"
                                style={{ fontSize: '11px' }}
                                onClick={() => this.handleElementChange(el.id, 'alignment', 'right')}
                              >
                                <AlignRight size={13} className="mr-1" /> Right
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Card>
                  );
                })
              )}
            </TabPane>

            {/* TAB 2: Document Settings */}
            <TabPane tabId="2">
              <div className="p-4 border shadow-sm" style={{ backgroundColor: '#ffffff', borderRadius: '12px', borderColor: '#cbd5e1' }}>
                <h6 className="font-weight-bold mb-3 d-flex align-items-center" style={{ color: '#0f172a' }}>
                  <Settings size={18} className="mr-2 text-primary" /> General Template Settings
                </h6>

                {/* Template Title Input */}
                <FormGroup className="mb-4">
                  <Label className="font-weight-bold mb-1" style={{ fontSize: '13px', color: '#0f172a' }}>
                    Template Title <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1', borderRadius: '8px', padding: '10px 14px', fontSize: '14px' }}
                    placeholder="e.g. NEBOSH Letter of Acknowledgement / Graphic Certificate"
                    value={title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                  />
                  <small className="form-text mt-1" style={{ color: '#64748b' }}>
                    Enter a descriptive title to identify this certificate or letter acknowledgement template.
                  </small>
                </FormGroup>

                {/* Active Default Checkbox Card */}
                <div className="p-3 mb-4 rounded d-flex align-items-center justify-content-between" style={{ backgroundColor: isDefault ? '#f0fdf4' : '#f8fafc', border: `1px solid ${isDefault ? '#86efac' : '#cbd5e1'}`, borderRadius: '8px', cursor: 'pointer' }} onClick={() => this.setState({ isDefault: !isDefault })}>
                  <div className="d-flex align-items-center">
                    <CheckCircle size={20} className={`mr-2 ${isDefault ? 'text-success' : 'text-secondary'}`} />
                    <div>
                      <strong style={{ color: '#0f172a', fontSize: '13px' }}>Set as Active Default Template</strong>
                      <small className="d-block" style={{ color: '#64748b' }}>
                        If enabled, courses without a custom template will automatically use this template.
                      </small>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center">
                    <input
                      type="checkbox"
                      style={{ width: '20px', height: '20px', cursor: 'pointer', accentColor: '#16a34a', margin: 0 }}
                      checked={isDefault}
                      onChange={(e) => this.setState({ isDefault: e.target.checked })}
                    />
                  </div>
                </div>

                {/* Background File Upload Card */}
                <div className="p-3 rounded" style={{ backgroundColor: '#f8fafc', border: '2px dashed #cbd5e1', borderRadius: '8px' }}>
                  <FormGroup className="mb-0">
                    <Label className="font-weight-bold mb-1 d-flex align-items-center" style={{ fontSize: '13px', color: '#0f172a' }}>
                      <FileText size={16} className="mr-2 text-primary" /> Background PDF / Image File (Optional)
                    </Label>
                    <Input
                      type="file"
                      accept="application/pdf,image/png,image/jpeg,image/jpg"
                      size="sm"
                      style={{ color: '#0f172a', backgroundColor: '#ffffff', borderColor: '#cbd5e1', padding: '6px' }}
                      onChange={(e) => this.setState({ pdfFile: e.target.files[0] })}
                    />
                    {existingPdfUrl ? (
                      <div className="mt-2 p-2 rounded bg-white border d-flex align-items-center justify-content-between">
                        <small style={{ color: '#334155', fontWeight: '500' }}>
                          Current Background: <strong style={{ color: '#0f172a' }}>{existingPdfUrl.split('/').pop()}</strong>
                        </small>
                        <a href={existingPdfUrl} target="_blank" rel="noopener noreferrer" className="btn btn-xs btn-outline-primary py-0 px-2 font-weight-bold" style={{ fontSize: '11px' }}>
                          View PDF
                        </a>
                      </div>
                    ) : (
                      <small className="form-text mt-1" style={{ color: '#64748b' }}>
                        Upload a custom PDF or image background. If empty, standard Trainovate branding will be used.
                      </small>
                    )}
                  </FormGroup>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    );
  };

  render() {
    const { templates, isLoading, isModalOpen, isEditMode, isPreviewOpen, previewPdfUrl, isGeneratingPreview } = this.state;
    const userEmail = (this.props.userEmail || '').toLowerCase();
    const isAuthorizedAdmin = userEmail === 'supportadmin@dharmatech.in';

    return (
      <React.Fragment>
        <Breadcrumb title="Certificate Templates" parent="Courses" />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card className="border shadow-sm" style={{ borderRadius: '12px', backgroundColor: '#ffffff' }}>
                <CardHeader className="bg-white border-bottom py-3 px-4 d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-1 font-weight-bold" style={{ color: '#0f172a' }}>Certificate & Letter Templates</h5>
                    <small style={{ color: '#64748b' }}>Design custom graphic certificates and letter acknowledgement templates</small>
                  </div>
                  {isAuthorizedAdmin && (
                    <Button
                      color="primary"
                      className="font-weight-bold shadow-sm"
                      style={{ background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)', border: 'none', borderRadius: '8px', padding: '8px 20px' }}
                      onClick={this.toggleModal}
                    >
                      <Plus size={16} className="mr-1" /> Create New Template
                    </Button>
                  )}
                </CardHeader>
                <CardBody className="p-0">
                  {isLoading ? (
                    <div className="text-center p-5">
                      <div className="spinner-border text-primary mb-2" role="status" />
                      <div style={{ color: '#475569', fontWeight: '500' }}>Loading certificate templates...</div>
                    </div>
                  ) : templates.length === 0 ? (
                    <div className="text-center p-5" style={{ color: '#475569' }}>
                      <FileText size={48} className="mb-3 text-primary opacity-5" />
                      <h6 className="font-weight-bold mb-1" style={{ color: '#0f172a' }}>No Certificate Templates Found</h6>
                      <p className="small mb-3" style={{ color: '#64748b' }}>Create custom certificate or letter acknowledgement templates for your courses.</p>
                      {isAuthorizedAdmin && (
                        <Button color="primary" size="sm" onClick={this.toggleModal}>
                          <Plus size={14} className="mr-1" /> Create Template Now
                        </Button>
                      )}
                    </div>
                  ) : (
                    <Table responsive hover className="mb-0 align-middle">
                      <thead style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                        <tr>
                          <th className="py-3 px-4" style={{ color: '#475569', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Template Title</th>
                          <th className="py-3 px-3" style={{ color: '#475569', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</th>
                          <th className="py-3 px-3" style={{ color: '#475569', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Elements</th>
                          <th className="py-3 px-3" style={{ color: '#475569', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Background PDF</th>
                          <th className="py-3 px-3" style={{ color: '#475569', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Created At</th>
                          <th className="py-3 px-4 text-right" style={{ color: '#475569', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates.map((tpl) => (
                          <tr key={tpl._id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                            <td className="py-3 px-4">
                              <div className="d-flex align-items-center">
                                <div className="p-2 mr-3 rounded" style={{ backgroundColor: '#f0f9ff', color: '#0284c7' }}>
                                  <FileText size={18} />
                                </div>
                                <div>
                                  <strong style={{ color: '#0f172a', fontSize: '14px' }}>{tpl.title}</strong>
                                  {tpl.is_default && (
                                    <Badge color="success" className="ml-2 py-1 px-2" style={{ backgroundColor: '#dcfce7', color: '#15803d', border: '1px solid #bbf7d0' }}>
                                      Default
                                    </Badge>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td className="py-3 px-3 align-middle">
                              {tpl.is_default ? (
                                <span className="badge badge-pill py-1 px-2 font-weight-bold" style={{ backgroundColor: '#dcfce7', color: '#15803d', border: '1px solid #86efac' }}>
                                  <CheckCircle size={12} className="mr-1" /> Active Default
                                </span>
                              ) : (
                                <span className="badge badge-pill py-1 px-2 font-weight-bold" style={{ backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}>
                                  Standard
                                </span>
                              )}
                            </td>
                            <td className="py-3 px-3 align-middle">
                              <span className="badge badge-pill py-1 px-2 font-weight-bold" style={{ backgroundColor: '#e0f2fe', color: '#0369a1', border: '1px solid #bae6fd' }}>
                                {(tpl.elements || []).length} Elements
                              </span>
                            </td>
                            <td className="py-3 px-3 align-middle">
                              {tpl.template_url ? (
                                <a
                                  href={tpl.template_url.startsWith('http') ? tpl.template_url : (WEBURL + tpl.template_url).replace(/([^:]\/)\/+/g, "$1")}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-xs btn-outline-info font-weight-bold py-1 px-2"
                                  style={{ borderRadius: '6px', fontSize: '12px' }}
                                >
                                  <FileText size={13} className="mr-1" /> {tpl.template_url.split('/').pop()}
                                </a>
                              ) : (
                                <span className="small font-weight-bold" style={{ color: '#94a3b8' }}>Default Sample Background</span>
                              )}
                            </td>
                            <td className="py-3 px-3 align-middle small" style={{ color: '#475569', fontWeight: '500' }}>
                              {new Date(tpl.createdAt).toLocaleDateString()}
                            </td>
                            <td className="py-3 px-4 align-middle text-right">
                              <Button
                                color="link"
                                size="sm"
                                className="mr-2 p-1"
                                style={{ backgroundColor: '#f0fdf4', color: '#16a34a', borderRadius: '6px' }}
                                onClick={() => this.handleRowPreview(tpl)}
                                title="Preview Full Rendered Certificate (with text elements)"
                              >
                                <Eye size={15} />
                              </Button>
                              {isAuthorizedAdmin && (
                                <React.Fragment>
                                  <Button
                                    color="link"
                                    size="sm"
                                    className="mr-2 p-1"
                                    style={{ backgroundColor: '#e0f2fe', color: '#0284c7', borderRadius: '6px' }}
                                    onClick={() => this.handleEdit(tpl)}
                                    title="Edit Template Studio"
                                  >
                                    <Edit2 size={15} />
                                  </Button>
                                  <Button
                                    color="link"
                                    size="sm"
                                    className="p-1"
                                    style={{ backgroundColor: '#fef2f2', color: '#ef4444', borderRadius: '6px' }}
                                    onClick={() => this.handleDelete(tpl._id)}
                                    title="Delete Template"
                                  >
                                    <Trash2 size={15} />
                                  </Button>
                                </React.Fragment>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Full-Screen Studio Modal */}
        <Modal
          isOpen={isModalOpen}
          toggle={this.toggleModal}
          style={{ maxWidth: '96vw', width: '96vw', margin: '2vh auto' }}
        >
          <ModalHeader
            toggle={this.toggleModal}
            style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#ffffff', padding: '14px 24px' }}
          >
            <div className="d-flex align-items-center">
              <FileText size={20} className="mr-2 text-primary" />
              <h5 className="mb-0 font-weight-bold text-white">
                {isEditMode ? 'Edit Certificate Studio Template' : 'Create New Certificate Studio Template'}
              </h5>
            </div>
          </ModalHeader>
          <Form onSubmit={this.handleSubmit} className="d-flex flex-column m-0" style={{ height: '82vh' }}>
            <ModalBody className="p-3" style={{ height: 'calc(82vh - 105px)', overflow: 'hidden', backgroundColor: '#f8fafc' }}>
              <Row className="h-100 m-0">
                {/* Left Column: Visual Canvas Stage */}
                <Col md={7} className="h-100 pr-2 pl-0">
                  {this.renderVisualCanvas()}
                </Col>

                {/* Right Column: Inspector Sidebar */}
                <Col md={5} className="h-100 pl-2 pr-0">
                  {this.renderInspectorPanel()}
                </Col>
              </Row>
            </ModalBody>

            <ModalFooter className="border-top py-2 px-3 d-flex justify-content-between align-items-center m-0" style={{ height: '50px', backgroundColor: '#ffffff', borderRadius: '0 0 0.3rem 0.3rem' }}>
              <Button
                color="link"
                size="sm"
                className="text-primary font-weight-bold d-flex align-items-center py-1 px-3"
                style={{ backgroundColor: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '6px', textDecoration: 'none', fontSize: '12px' }}
                onClick={this.handleGeneratePreview}
                disabled={isGeneratingPreview}
              >
                <Eye size={14} className="mr-1 text-primary" />
                <span>{isGeneratingPreview ? 'Generating...' : 'Live PDF Preview'}</span>
              </Button>
              <div className="d-flex align-items-center">
                <Button
                  color="light"
                  size="sm"
                  className="mr-2 font-weight-bold py-1 px-3"
                  style={{ color: '#475569', backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '6px', fontSize: '12px' }}
                  onClick={this.toggleModal}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  size="sm"
                  type="submit"
                  className="font-weight-bold shadow-sm py-1 px-3"
                  style={{ background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)', border: 'none', borderRadius: '6px', fontSize: '12px' }}
                  disabled={isLoading}
                >
                  {isLoading ? 'Saving...' : isEditMode ? 'Update Template' : 'Save Template'}
                </Button>
              </div>
            </ModalFooter>
          </Form>
        </Modal>

        {/* Live PDF Preview Modal */}
        <Modal
          isOpen={isPreviewOpen}
          toggle={() => this.setState({ isPreviewOpen: !isPreviewOpen })}
          style={{ maxWidth: '90vw', width: '90vw', margin: '3vh auto' }}
        >
          <ModalHeader
            toggle={() => this.setState({ isPreviewOpen: !isPreviewOpen })}
            style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#ffffff' }}
          >
            <h5 className="mb-0 text-white font-weight-bold">Live Certificate PDF Preview</h5>
          </ModalHeader>
          <ModalBody style={{ height: '80vh', padding: 0 }}>
            {previewPdfUrl ? (
              <iframe
                src={previewPdfUrl}
                title="Certificate Preview"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
              />
            ) : (
              <div className="p-4 text-center">Failed to load preview</div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.setState({ isPreviewOpen: false })}>Close</Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  let email = state.auth?.loginUserData?.email || state.auth?.user?.email || localStorage.getItem('email') || localStorage.getItem('userEmail') || '';
  if (!email) {
    try {
      const userObj = JSON.parse(localStorage.getItem('loginUserData') || localStorage.getItem('user') || localStorage.getItem('user_details') || '{}');
      email = userObj.email || '';
    } catch (e) {}
  }
  return {
    authtoken: state.auth?.authToken || state.auth?.token || state.auth?.user?.token || localStorage.getItem('authToken') || localStorage.getItem('authtoken') || localStorage.getItem('token'),
    userEmail: email,
  };
};

export default connect(mapStateToProps)(CertificateTemplates);
